import { render } from "./BottomSheet.vue?vue&type=template&id=f825b276&scoped=true"
import script from "./BottomSheet.vue?vue&type=script&lang=js"
export * from "./BottomSheet.vue?vue&type=script&lang=js"

import "./BottomSheet.vue?vue&type=style&index=0&id=f825b276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f825b276"]])

export default __exports__